import React, { useState } from "react";
import Loader from "../common/Loader";
import { useTheme } from "../ThemeContext";

function SystemSettings() {
  const [loading, setLoading] = useState(true);
  const { theme } = useTheme();

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="inc-card ch-100">
          <div className="inc-card-title">
            <h3>System Information</h3>
          </div>
          <div className="inc-card-body">
            {loading && <Loader />}
            <iframe
              src={`https://inc.dev.vvdncloud.com:3001/d/jMrPmiSnk/docker-containers?orgId=1&refresh=30s&kiosk&theme=${theme}`}
              width="100%"
              height="735px"
              frameBorder="0"
              title="Docker Containers"
              style={{ display: loading ? "none" : "block", background: "transparent" }}
              onLoad={() => setLoading(false)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SystemSettings;
